import { Component, OnInit,ViewChild } from "@angular/core";
import * as utils from "../services/comment";

import { HttpBaseService } from "../services/httpBase.service";
import api from "../api";
import { NzMessageService } from "ng-zorro-antd";


@Component({
  selector: "app-search-form",
  templateUrl: "./search-form.component.html",
  styleUrls: ["./search-form.component.less"]
})
export class SearchFormComponent implements OnInit {
  // 定时器
  name: string;
  showSearch: boolean;
  seachTime: boolean;
  showSelect: boolean;
  showNameList: boolean;
  pwdIsShow: boolean;
  user: Array<any>;
  userShow: boolean;
  nameList: Array<any>;
  menuList: Array<any>;
  successLoginInfo: object;
  @ViewChild('searchForm') searchForm;
  constructor(private http: HttpBaseService, private _msg: NzMessageService) {
    this.showSearch = false;
    this.seachTime = true;
    this.showSelect = false;
    this.showNameList = false;
    this.pwdIsShow = false;
    this.userShow = false;
    this.nameList = [];
    this.menuList = [];
    this.user = [];
  }

  options = [
    { value: 'correspondence', label: '通讯录', select: true },
    { value: 'menu', label: '菜单', select: false },
  ];
  seachType = this.options[0];

  ngOnInit() {
  }
  showPwdModal() {
    this.pwdIsShow = true;
  }
  //   模糊查询10个姓名
  list(e) {
    const s = this.seachType.value
    if (this.name && e.keyCode !== 13) {
      if (s == 'correspondence') {
        this.http
          .post(api.findByName, {
            params: JSON.stringify({
              name: this.name
            })
          })
          .subscribe(res => {
            if (res.status === "S") {
              if (this.name) {
                this.nameList = res.data[0];
                this.showNameList = true;
              }
            } else {
              this._msg.warning(res.msg);
            }
          });
      } else {
        this.getData()
      }

    } else {
      this.nameList = [];
      this.menuList = [];
    }
    if (e.keyCode === 13) {
      if (s == 'correspondence') {
        this.search();
      } else {
        this.getData()
      }

    }
  }

  getName(name: any) {
    this.name = name;
    this.nameList = [];
    document.getElementById("searchForm").focus();
  }

  getData() {
    const s = this.seachType.value
    if (s == 'correspondence') {
      this.http
        .post(api.findByCondition, {
          params: JSON.stringify({
            name: this.name
          })
        })
        .subscribe(res => {
          if (res.status === "S") {
            this.user = res.data[0];
            this.userShow = true;
          } else {
            this._msg.warning(res.msg);
          }
        });
    } else {
      if (this.name) {
        this.http
          .post(api.findMenuList, {
            params: JSON.stringify({
              menuName_like: this.name
            })
          })
          .subscribe(res => {
            this.menuList = res.data;
          });
      }

    }
  }

  // 通讯录查询列表
  search() {

    if (this.name) {
      this.getData()
    }
  }

  seachClick() {
    this.showSelect = !this.showSelect;
  }

  selectItem(index) {
    this.options.map((key, value) => {
      this.options[value]['select'] = false
    })
    this.options[index]['select'] = true
    this.seachType = this.options[index];
    this.showSelect = false;
    this.showSearch = true;
  }
  golink(menu) {
    let host = window.location.host
    let _urlobj = [{
      name: menu.menuName,
      url: menu.htmlUrl.replace('/', ''),
      id: menu.menuId,
      active: true
    }]
    let headTab = menu.systemName + '_headTab'
    let certificate = menu.systemName + '_certificate'
    let successLoginInfo = menu.systemName + '_successLoginInfo'
    let languageList = menu.systemName + '_languageList'
    sessionStorage[headTab] = utils.Base64.encode(JSON.stringify(_urlobj));
    sessionStorage[certificate] = sessionStorage.getItem('certificate');
    sessionStorage[languageList] = sessionStorage.getItem('languageList');
    sessionStorage[successLoginInfo] = sessionStorage.getItem('successLoginInfo');
    localStorage[successLoginInfo] = sessionStorage.getItem('successLoginInfo');


    let a = document.getElementById("golink")
    let _url = '//' + host + '/saaf/#/' + menu.systemCode.toLowerCase() + '/main'
    a.setAttribute('href', _url)
    a.click()
  }

  mouseover(event) {
    console.log('mouseover')
    console.log(this.name)
    if (this.name === undefined || this.name === "") {
      this.showSearch = true;
      this.seachTime=false;
    }else{
      this.showSearch = true;
      this.seachTime=false;
    }
  }

  mouseout(event) {
    console.log('mouseout')
    if (this.name === undefined || this.name === "") {
      if(this.seachTime)return;
        setTimeout(()=>{
          if(this.seachTime)return;
          this.searchForm.nativeElement.blur();
          this.showSearch = false;
          this.showSelect = false;
          this.seachTime=true;
        },10000)


    }
  }

  Cancel() {
    this.userShow = false;
  }
}



// WEBPACK FOOTER //
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/search-form/search-form.component.ts